import OfficeBuilding from './OfficeBuilding.jsx'; // תכף נבנה
import Wrapper from '../../assets/wrappers/JobsContainer';
import { useAllOfficesContext } from '../../pages/AllOfficeBuildings.jsx';
import OfficeBuildingPaginationContainer from './OfficeBuildingPaginationContainer.jsx';

const OfficesContainer = () => {
  const { data } = useAllOfficesContext();
  const { floorNavigations, total, numOfPages } = data;
  
  if (!floorNavigations || floorNavigations.length === 0) {
    return (
      <Wrapper>
        <h5>לא נמצאו בנייני משרדים להציג...</h5>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>נמצאו {total} בנייני משרדים</h5>
      <div className='jobs'>
        {floorNavigations.map((building) => (
          <OfficeBuilding key={building._id} {...building} />
        ))}
      </div>
      {numOfPages > 1 && <OfficeBuildingPaginationContainer />}
    </Wrapper>
  );
};

export default OfficesContainer;
